module.exports = __webpack_public_path__ + "static/media/AIInFinance1.d9338116.jpg";